module.exports = __webpack_public_path__ + "static/assets/6e2bc761e73fcea52f7b3c7fc475330e.svg";